import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=09f3062a&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=09f3062a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../pwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3062a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
